import { DMAutomationContentButton } from "@markit/common.types";
import { Colors } from "../../../../utils/colors";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { getEventState } from "../../../../redux/slices/eventSlice";
import { useMemo } from "react";
import { getAccountState } from "../../../../redux/slices/accountSlice";
import { getSubscribeCampaignAsForm } from "../../../../utils/eventUtils/formUtils";
import { FormProfileItemImage } from "../../../DisplayItem/FormItem/FormProfileItemImage";
import EventItemImage from "../../../DisplayItem/EventItem/EventItemImage";

type DMAutomationContentButtonItemProps = {
  contentButton: DMAutomationContentButton;
  removeOnPress: () => void;
};

const DMAutomationContentButtonItem = (
  props: DMAutomationContentButtonItemProps
) => {
  const { contentButton, removeOnPress } = props;
  const { events } = useSelector(getEventState).events;
  const { username, profilePicURL, isAdmin } =
    useSelector(getAccountState).account.accountData;

  const subscribeCampaignAsForm = useMemo(
    () => getSubscribeCampaignAsForm(username, profilePicURL, isAdmin),
    [username, profilePicURL, isAdmin]
  );

  const foundEvent = useMemo(
    () => events.find((event) => contentButton.url.includes(event.id)),
    [contentButton.url, events]
  );

  const isSubscribeForm = useMemo(
    () => contentButton.url.includes(username + "/subscribe"),
    [contentButton.url, username]
  );

  return (
    <div
      style={{
        backgroundColor: Colors.WHITE1,
        padding: 10,
        borderRadius: 12,
        width: 240,
        gap: 14,
        border: `1.5px solid ${Colors.GRAY11}`,
      }}
      className="AlignedRowSpaced"
    >
      <div className="AlignedRow" style={{ gap: 10, flex: 1 }}>
        {isSubscribeForm ? (
          <FormProfileItemImage item={subscribeCampaignAsForm} size={40} />
        ) : foundEvent ? (
          <EventItemImage item={foundEvent} size={40} />
        ) : null}
        <div className="ColumnNormal" style={{ gap: 4, flex: 1 }}>
          <span className="bodyMedium">{contentButton.title}</span>
          <div className="AlignedRow" style={{ gap: 4 }}>
            <span className="smallBodySubtext OneLineText">
              {isSubscribeForm
                ? "Link to Subscribe"
                : foundEvent
                  ? foundEvent.title
                  : contentButton.url}
            </span>
            <Icon
              onClick={removeOnPress}
              icon="mdi:link-variant"
              height={14}
              style={{ color: Colors.BLUE5, marginBottom: -1, flexShrink: 0 }}
            />
          </div>
        </div>
      </div>
      <Icon
        onClick={removeOnPress}
        icon="ion:close-circle"
        height={28}
        style={{ color: Colors.BLACK, cursor: "pointer" }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
      />
    </div>
  );
};

export default DMAutomationContentButtonItem;
